<template>
  <div class="dataDictionary">
    <el-card class="box-card" shadow="never">
      <el-button icon="el-icon-back" v-if="active !== -1" style="float: left;" type="primary" @click="setActive(-1)">返回</el-button>
      <div v-show="active === -1">
        <el-button icon="el-icon-plus" type="primary" @click="openAddRowDlg">新增字典名称</el-button>
        <el-table :data="tableData" ref="tbl" border max-height="600" style="width: 100%; margin-top: 20px;" tooltip-effect="dark">
          <el-table-column type="index" label="序号" width="180" fixed></el-table-column>
          <el-table-column prop="dictName" label="字典表名称" fixed show-overflow-tooltip></el-table-column>
          <el-table-column prop="dictStatus" label="状态">
            <template slot-scope="scope">
              <el-switch size="mini" v-model="scope.row.dictStatus" active-text="启用" @change="res => switchStatus(1, res, scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center">
            <template slot-scope="{ row }">
              <el-button class="text-btn" type="text" size="small" @click="toDictionaryDetail(row)">
                <i class="el-icon-view" />
                <span class="mg-left">详情</span>
              </el-button>
              <el-button class="text-btn" type="text" size="small" @click="toDictionaryConfig(row)">
                <i class="el-icon-edit" />
                <span class="mg-left">编辑</span>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :total="total" :page-sizes="pageList" :page-size="pages.size" layout="total, sizes, prev, pager, next, jumper" style="text-align: center; margin-top:20px"></el-pagination>
      </div>
      <DictionaryDetail v-if="active === 0" :dictInfoId="dictInfoId" :dictionaryName="dictionaryName" :isType="isType"></DictionaryDetail>
    </el-card>
    <Dialog ref="dlgAddDictionary" title="新建字典表名称">
      <el-form ref="addDictionaryForm" :model="addDictionaryForm" :rules="rules" label-width="140px">
        <el-form-item label="请输入字典表名称" prop="dictionaryName">
          <el-input v-model="addDictionaryForm.dictionaryName" style="width: 240px;"></el-input>
        </el-form-item>
        <el-form-item style="text-align:center" class="btn-tools">
          <el-button class="btn" type="primary" @click="saveForm('addDictionaryForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </Dialog>
  </div>
</template>

<script>
  import Dialog from '@/components/dialog';
  import DATADICTIONARYAPI from '@/api/dataDictionary';
  import DictionaryDetail from './dictionaryDetail';

  export default {
    components: {
      Dialog,
      DictionaryDetail
    },
    data() {
      return {
        active: -1,         // -1-字典表列表页、0-编辑页、详情页
        isType: 'edit',     // edit-编辑、detail-详情

        pages: { page: 1, size: 10 },
        pageList: [10, 20, 30, 50, 100],
        total: 0,
        tableData: [],

        addDictionaryForm: {
          dictionaryName: '',
        },
        rules: {
          dictionaryName: [{
            required: true,
            message: '请输入字典表名称',
            trigger: 'blur'
          }]
        },
        dictInfoId: 0,
        dictionaryName: 0,
      };
    },
    computed: {},
    methods: {
      setActive(v) {
        this.active = v;
        this.searchDictInfoListByPage();
      },

      // 新增一行
      openAddRowDlg() {
        this.$refs.dlgAddDictionary.open();
      },

      switchStatus(index, res, row) {
        const params = {
          id: row.id,
        };
        params.dictStatus = res ? 0 : 1;      // 0-启用，1-禁用
        DATADICTIONARYAPI.enableOrDisableDict(params).then(res => {
          if (res.data.code === 200) {
            this.$message.success('操作成功');
            this.searchDictInfoListByPage();
          }
        });
      },

      // 详情页
      toDictionaryDetail(row) {
        this.isType = 'detail';
        this.active = 0;
        this.dictInfoId = row.id;
        this.dictionaryName = row.dictionaryName;
      },
      // 配置
      toDictionaryConfig(row) {
        this.isType = 'edit';
        this.active = 0;
        this.dictInfoId = row.id;
        this.dictionaryName = row.dictionaryName;
      },

      saveForm() {
        this.$refs.addDictionaryForm.validate(valid => {
            if (valid) {
              const params = {
                dictName: this.addDictionaryForm.dictionaryName
              };
              DATADICTIONARYAPI.addDictInfo(params).then(res => {
                if (res.data.code === 200) {
                  this.$message.success('操作成功');
                  this.searchDictInfoListByPage();
                }
              });
              this.$refs.dlgAddDictionary.close();
            }
        })
      },
      handleSizeChange(v) {
        this.pages.size = v;
        this.searchDictInfoListByPage();
      },
      handleCurrentChange(v) {
        this.pages.page = v;
        this.searchDictInfoListByPage();
      },

      // 查询字字典表列表(带分页)
      searchDictInfoListByPage() {
        let self = this;
        let params = self.pages;
        DATADICTIONARYAPI.searchDictInfoListByPage(params).then(res => {
          if (res.data.code === 200 && !res.data.errors) {
            this.tableData = res.data.data.records.map(obj => {
              obj.dictStatus = obj.dictStatus === 0;
              return obj;
            });
            this.total = res.data.data.total;
            this.$nextTick(function () {
              self.$refs.tbl.doLayout();
            });
          }
          if (res.data.errors) {
            this.$message.error(res.data.errors);
          }
        });
      },
    },

    created() {
      // 获取字典表列表
      this.searchDictInfoListByPage();
    }
  };
</script>

<style lang="scss" scoped>
  .dataDictionary {
    .box-card {
      .text-btn {
        padding: 0 20px;
        font-size: 12px !important;

        &span {
          font-size: 12px !important;
        }
      }

      .btn-tools {
        text-align: center;
        margin-top: 35px;

        .btn {
          width: 100px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/boss/dataDictionary/index.vue